import { authActions } from './../../app/modules/auth/redux/AuthSlice';
import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';

import * as auth from '../../app/modules/auth';
import * as home from '../../app/modules/home/redux';
import * as ticket from '../../app/modules/tickets/redux';
import * as user from '../../app/modules/users/redux';
import { PayloadAction } from '@reduxjs/toolkit';
import * as onlineBooking from '../../app/modules/online-booking/redux';
import * as serviceManagement from '../../app/modules/service-management/redux';
import * as growthAndMarketingManagement from 'app/modules/growth-marketing/redux';
import * as busyTime from '../../app/modules/busy-time/redux';
import * as customer from '../../app/modules/customers/redux';
import * as housing from '../../app/modules/operation-setup/housing/redux';
import * as operationSetupZones from '../../app/modules/operation-setup/zones/redux';
import * as dispatch from '../../app/modules/operation-setup/dispatch/redux';
import * as merchantOnboarding from '../../app/modules/operation-setup/payment-gateway/redux';
import * as setting from '../../app/modules/pwa-control/redux';
import * as trip from '../../app/modules/trip/redux';
import * as payments from '../../app/modules/payments/redux';

const mainReducer = combineReducers({
  auth: auth.authReducer,
  home: home.homeReducer,
  ticket: ticket.ticketReducer,
  user: user.userReducer,
  onlineBooking: onlineBooking.onlineBookingReducer,
  serviceManagement: serviceManagement.serviceManagementReducer,
  growthAndMarketingManagement: growthAndMarketingManagement.growthAndMarketingReducer,
  busyTime: busyTime.busyTimeReducer,
  customer: customer.customerReducer,
  housing: housing.housingReducer,
  zoneDistrict: operationSetupZones.districtReducer,
  dispatch: dispatch.dispatchReducer,
  merchantOnboarding: merchantOnboarding.merchantOnboardingReducer,
  setting: setting.settingReducer,
  trip: trip.tripReducer,
  payments: payments.paymentsReducer,
})

export const rootReducer = (state: any, action: PayloadAction) => {
  return action.type === authActions.logout.type ? mainReducer({ auth: state.auth } as any, action) : mainReducer(state, action);
}

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([
    auth.authSaga(),
    home.homeSaga(),
    ticket.ticketSaga(),
    user.UserSaga(),
    onlineBooking.onlineBookingSaga(),
    serviceManagement.serviceManagementSaga(),
    growthAndMarketingManagement.growthAndMarketingSaga(),
    busyTime.busyTimeSaga(),
    housing.housingSaga(),
    operationSetupZones.districtSaga(),
    dispatch.dispatchSaga(),
    merchantOnboarding.merchantOnboardingSaga(),
    setting.settingSaga(),
    trip.tripSaga(),
    payments.paymentsSaga(),
  ])
}